import script from "./GroupMeeting.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupMeeting.vue?vue&type=script&setup=true&lang=ts"

import "./GroupMeeting.vue?vue&type=style&index=0&id=9c2b3d80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c2b3d80"]])

export default __exports__